import React, { useState, useEffect } from 'react';
import {
  getAllBlogs,
  saveCustomBlog,
  updateBlog,
  deleteBlog,
  blogToForm,
  emptyForm,
  isCustomBlog,
} from '../../common/blogStore';
import { inputStyle, cardStyle, formBoxStyle } from './adminShared';

function AdminBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    refreshBlogs();
  }, []);

  async function refreshBlogs() {
    try {
      setLoading(true);
      setError('');
      setBlogs(await getAllBlogs());
    } catch (err) {
      setError(err.message || 'Bloglar yüklenemedi.');
    } finally {
      setLoading(false);
    }
  }

  function resetForm() {
    setForm(emptyForm);
    setEditingId(null);
    setShowForm(false);
  }

  function openCreateForm() {
    setEditingId(null);
    setForm(emptyForm);
    setShowForm(true);
  }

  function openEditForm(blog) {
    setEditingId(blog.id);
    setForm(blogToForm(blog));
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.title || !form.excerpt) return;

    const payload = {
      ...form,
      tags: form.tags
        ? form.tags.split(',').map((t) => t.trim()).filter(Boolean)
        : [form.category || 'Genel'],
    };

    try {
      setError('');
      if (editingId) {
        await updateBlog(editingId, payload);
      } else {
        await saveCustomBlog(payload);
      }
      resetForm();
      await refreshBlogs();
    } catch (err) {
      setError(err.message || 'Kayıt işlemi başarısız.');
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Bu blog yazısını silmek istediğinize emin misiniz?')) return;
    try {
      setError('');
      await deleteBlog(id);
      if (editingId === id) resetForm();
      await refreshBlogs();
    } catch (err) {
      setError(err.message || 'Silme işlemi başarısız.');
    }
  }

  const customCount = blogs.filter((b) => isCustomBlog(b.id)).length;

  return (
    <>
      <div className="sec-head mb-50">
        <div className="d-flex align-items-center flex-wrap">
          <div>
            <span className="sub-title main-color mb-5">Yönetim Paneli</span>
            <h3 className="fw-600 fz-40">Blog Yönetimi</h3>
          </div>
          <div className="ml-auto">
            <button
              onClick={() => (showForm && !editingId ? resetForm() : openCreateForm())}
              className="butn butn-sm butn-bg main-colorbg radius-5"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              <span className="text">
                {showForm && !editingId ? 'Formu Kapat' : '+ Yeni Blog'}
              </span>
            </button>
          </div>
        </div>
        <p className="p-color mt-15 fz-14">
          Toplam {blogs.length} yazı ({customCount} admin tarafından eklendi) —{' '}
          <a href="/blog-classic" className="main-color">Blogu Görüntüle</a>
        </p>
        {error && <p className="main-color mt-15 fz-14">{error}</p>}
        {loading && <p className="p-color mt-15 fz-14">Yükleniyor...</p>}
      </div>

      {showForm && (
        <div className="mb-60 p-40" style={formBoxStyle}>
          <div className="d-flex align-items-center mb-30">
            <h5 className="mb-0">
              {editingId ? 'Blog Yazısını Düzenle' : 'Yeni Blog Yazısı Ekle'}
            </h5>
            {editingId && (
              <button
                type="button"
                onClick={resetForm}
                className="ml-auto p-color fz-14"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Düzenlemeyi İptal Et
              </button>
            )}
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row lg-marg">
              <div className="col-lg-6">
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Başlık *</label>
                  <input type="text" name="title" value={form.title} onChange={handleChange} required style={inputStyle} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Vurgulu Kısım (ince yazı)</label>
                  <input type="text" name="titleHighlight" value={form.titleHighlight} onChange={handleChange} style={inputStyle} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Kategori</label>
                  <input type="text" name="category" value={form.category} onChange={handleChange} style={inputStyle} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Kapak Resmi URL</label>
                  <input type="text" name="coverImg" value={form.coverImg} onChange={handleChange} style={inputStyle} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Yazar</label>
                  <input type="text" name="author" value={form.author} onChange={handleChange} style={inputStyle} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Yayın Tarihi</label>
                  <input type="date" name="date" value={form.date} onChange={handleChange} style={inputStyle} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Etiketler (virgülle ayırın)</label>
                  <input type="text" name="tags" value={form.tags} onChange={handleChange} style={inputStyle} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Kısa Özet *</label>
                  <textarea name="excerpt" value={form.excerpt} onChange={handleChange} rows={3} required style={{ ...inputStyle, resize: 'vertical' }} />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">İçerik</label>
                  <textarea name="content" value={form.content} onChange={handleChange} rows={10} style={{ ...inputStyle, resize: 'vertical' }} />
                </div>
                {form.coverImg && (
                  <div style={{ borderRadius: '8px', overflow: 'hidden', maxHeight: '160px' }}>
                    <img src={form.coverImg} alt="Önizleme" style={{ width: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                )}
              </div>
            </div>
            <div className="mt-30 d-flex align-items-center" style={{ gap: '12px' }}>
              <button type="submit" className="butn butn-sm butn-bg main-colorbg radius-5" style={{ border: 'none', cursor: 'pointer' }}>
                <span className="text">{editingId ? 'Güncelle' : 'Blogu Yayınla'}</span>
              </button>
              {editingId && (
                <button type="button" onClick={resetForm} className="butn butn-sm butn-bord radius-30" style={{ border: 'none', cursor: 'pointer' }}>
                  <span>İptal</span>
                </button>
              )}
            </div>
          </form>
        </div>
      )}

      <div className="row lg-marg">
        {blogs.map((blog) => (
          <div key={blog.id} className="col-lg-4 col-md-6 mb-40">
            <div style={cardStyle}>
              {blog.coverImg && (
                <div style={{ height: '160px', overflow: 'hidden' }}>
                  <img src={blog.coverImg} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
              )}
              <div style={{ padding: '20px' }}>
                <span className="sub-title main-color fz-12">{blog.category}</span>
                <h6 className="mt-10 mb-10">{blog.title} {blog.titleHighlight}</h6>
                <p className="p-color fz-13 mb-20">{blog.excerpt?.slice(0, 80)}...</p>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                  <a href={`/blog-details/${blog.id}`} className="butn butn-sm butn-bord radius-30" target="_blank" rel="noopener noreferrer">
                    <span>Görüntüle</span>
                  </a>
                  <button onClick={() => openEditForm(blog)} className="butn butn-sm butn-bord radius-30" style={{ border: 'none', cursor: 'pointer' }}>
                    <span>Düzenle</span>
                  </button>
                  <button onClick={() => handleDelete(blog.id)} className="butn butn-sm radius-30" style={{ border: '1px solid rgba(255,80,80,0.4)', color: '#ff6b6b', background: 'transparent', cursor: 'pointer' }}>
                    <span>Sil</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default AdminBlogs;
